export function debounce(func, delay) {
    let timeout;
    return (...args) => {
        clearTimeout(timeout);
        timeout = setTimeout(() => func(...args), delay);
    };
}
export const indianMobileFilter = (value) => {
    const digits = String(value).replace(/\D/g, '');

    if (digits.length === 1 && !/[6-9]/.test(digits)) {
        return '';
    }

    return digits;
};
export const intFilter = (numberString) => {
    numberString = numberString + ''
    return numberString.replace(/\D/g, '')
}
export const redirectToLogin = () => {
    if (window.location.origin.includes('mavenconnect.tech')) window.location.replace('https://mavenconnect.tech/cargo')
    else if (window.location.origin.includes('mavenconnect.biz')) window.location.replace('https://mavenconnect.biz/cargo')
    else window.location.replace('https://mavenconnect.tech/cargo')
}
export const API_CACHE_DURATION = 24 * 60 * 60 * 1000;
const getToken = () => {
    const tokenString = sessionStorage.getItem('token');
    const userToken = JSON.parse(tokenString);
    return userToken?.token
};

const header = () => ({ 'Content-Type': 'application/json;charset=UTF-8', 'Accept': 'application/json', 'token': getToken() || "AmxsG7zkJB" })

const isLocalHost = window.location.origin.includes('localhost');

const GLOBAL_QUERY_PARAMS = { usage: 'dev',}
// isLocalHost ? {
//     usage: 'dev',
// } : {};


export const buildQueryString = (params = {}) => {
    const mergedParams = {
        ...params,
        ...GLOBAL_QUERY_PARAMS,

    };
    const entries = Object.entries(mergedParams);

    if (!entries.length) return '';
    return entries
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join('&');
};
export const createApiClient = () => {
    const getCache = new Map();
    const postCache = new Map();

    const readCache = (cache, key, duration) => {
        const entry = cache.get(key);
        if (!entry) return null;

        if (Date.now() - entry.timestamp > duration) {
            cache.delete(key);
            return null;
        }

        return entry.data;
    };

    const writeCache = (cache, key, data) => {
        cache.set(key, {
            data,
            timestamp: Date.now(),
        });
    };


    const apiGet = async (
        url,
        params,
        useCache = false,
        cacheDuration = API_CACHE_DURATION,
    ) => {
        const fullUrl = url + "?" + buildQueryString(params);
        const cacheKey = fullUrl;

        if (useCache) {
            const cached = readCache(getCache, cacheKey, cacheDuration);
            if (cached) return cached;
        }

        const response = await fetch(fullUrl, { headers: header() });
        if (response.status === 401) {
            redirectToLogin();
            return;
        }

        const data = await response.json();

        if (useCache) {
            writeCache(getCache, cacheKey, data);
        }

        return data;
    };
    const apiPost = async (
        url,
        payload,
        useCache = false,
        cacheDuration = API_CACHE_DURATION,
    ) => {

        const cacheKey = JSON.stringify({ url, payload });

        if (useCache) {
            const cached = readCache(postCache, cacheKey, cacheDuration);
            if (cached) return cached;
        }

        const response = await fetch(url, {
            method: 'POST',
            body: JSON.stringify(payload),
            headers: header(),
        });

        if (response.status === 401) {
            redirectToLogin();
            return;
        }

        const data = await response.json();

        if (useCache) {
            writeCache(postCache, cacheKey, data);
        }

        return data;
    };

    const clearGetCache = () => getCache.clear();
    const clearPostCache = () => postCache.clear();
    return {
        apiGet,
        apiPost,
        clearGetCache,
        clearPostCache,
    };
};

export const {
    apiGet,
    apiPost,
    clearGetCache,
    clearPostCache,
} = createApiClient();

export const formatToDDMMMYYYY = (dateStr) => {
    if (!dateStr) return "";

    const d = new Date(dateStr);

    // If valid date (ISO or parseable format)
    if (!isNaN(d)) {
        return d
            .toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" })
            .replace(/ /g, "-");
    }

    // Fallback for "04-Feb-2026 11:00 PM"
    return dateStr.split(" ")[0];
};
